module.exports = __webpack_public_path__ + "img/email_sent.8f6c9f3d.svg";